export const formatMessage = (template, vars = {}) =>
  Object.entries(vars).reduce(
    (msg, [key, value]) => msg.replace(new RegExp(`\\{${key}\\}`, "g"), value),
    template || ""
  );

export const resolveCarSpecValue = (car, row, context, helpers = {}) => {
  const { brands, model } = context;
  const getBrandName = helpers.getBrandName || ((id) => brands.find((b) => b.id === id)?.name || "-");
  const getModelName = helpers.getModelName || ((id) => model.find((m) => m.id === id)?.name || "-");

  switch (row.type) {
    case "image":
      return car.images?.[0] || "";
    case "title":
      return `${car.year} ${getBrandName(car.brand_id)} ${getModelName(car.model_id)}`;
    case "currency":
      return car[row.key] ?? 0;
    case "km":
      return car[row.key] ?? 0;
    case "percent":
      return car[row.key] ?? 0;
    case "lookup": {
      const list = context[row.lookup] || [];
      const item = list.find((entry) => entry.id === car[row.key]);
      return item?.name || "-";
    }
    default:
      return car[row.key] ?? "-";
  }
};

export const formatSpecDisplay = (value, row) => {
  switch (row.type) {
    case "currency":
      return `₹${Number(value).toLocaleString("en-IN")}`;
    case "km":
      return `${Number(value).toLocaleString("en-IN")} km`;
    case "percent":
      return `${value}%`;
    default:
      return value ?? "-";
  }
};
